import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Box,
  Grid,
  IconButton,
  InputAdornment,
  Tooltip,
  Typography,
  Dialog,
} from "@mui/material";
import { Button, Input, InputMultImg, Select } from "../../controls";
import { DropLi, Model, UseForm } from "../../hooks";
import { useNavigate, useParams } from "react-router-dom";
import { PercentRounded, ViewWeekRounded } from "@mui/icons-material";
import { controller, endpoints } from "../../api/actions/api";
import * as actions from "../../api/actions/pos";
import AddEditInventory from "../inventory/AddEditInventory";
import { connect } from "react-redux";
import {
  IsEmptyObj,
  MaxLength,
  RmvEmptyProp,
  RmvNullProp,
  ToFormData,
} from "../../hooks/Method";
import { Snackbar } from "../../layout";
import { safeOnComplete } from "../../utils/safeOnComplete";

  const ACTIONS = {
    EXIT: "exit",
    ADD_ANOTHER: "add_another",
  };

const AddEditProd = (props) => {
  const { t } = useTranslation();
  const {
    _post,
    _put,
    _data,
    _get,
    _clear,

    _getById,
    _store,
    _authUser,
   
    // ✅ ADD THESE (non-breaking)
    from,        // "pos" | undefined
    onSaved,     // function(product)
    //returnTo,    // "pos" | "purchase" | "product" | undefined
    
    _categoriesList,   // ✅ ADD THIS
    setAlert,            // ✅ ADD THIS

  } = props;

  const { ProdMdl } = Model();
  const { id } = useParams();
  const { UnitType, BoolType } = DropLi();
  const navigate = useNavigate();

  const [snackbar, setSnackbar] = useState({
    type: "success",
    msg: "",
    show: false,
  });
  const [loader, setLoader] = useState(false);

  const {
    values,
    setValues,
    errors,
    setErrors,
    handleInpChg,
    handleFile,
    resetFormControls,
  } = UseForm(ProdMdl);

  const categories = 
   (_categoriesList ?? [])
      ?.filter((j) => j.parentCatId === 0)
      ?.map((j) => ({
        id: j.id,
        name: j.name,
    }));
    
  const [subCat, setSubCat] = useState([]);
  const [imgSrc, setImgSrc] = useState([]);

  const [showInventoryForm, setShowInventoryForm] = useState(false);
  const [newProduct, setNewProduct] = useState(null);
  //const [showPurchForm, setShowPurchForm] = useState(false);
 
  const [afterInventoryAction, setAfterInventoryAction] = useState(null);

const validateForm = () => {
  let temp = {};

  temp.name =
    values.name !== "" ? "" : t("nameRequired");

  temp.barcode =
    values.barcode !== "" ? "" : t("barcodeRequired");

  temp.unit =
    values.unit !== "" ? "" : t("unitTypeRequired");

  temp.unitsPerPackage =
    [1, 4, 5].includes(Number(values.unit)) &&
    Number(values.unitsPerPackage) < 1
      ? t("unitsPerPackageRequired")
      : "";

  temp.tax =
    values.tax !== "" ? "" : t("taxRequired");

  temp.purchPrice =
    values.purchPrice !== "" ? "" : t("purchasePriceRequired");

  temp.sellPrice =
    values.sellPrice !== "" ? "" : t("sellPriceRequired");

  setErrors({ ...temp });
  return Object.values(temp).every((x) => x === "");
};

  const handleSubmit = (action = null) => {

    if (validateForm()) {
      setLoader(true);

    const onComplete = safeOnComplete(
      
      (res) => {
        setLoader(false);

        const status = res?.status ?? res?.statusCode;

        if (![200, 201, "200", "201"].includes(status)) {
            setLoader(false);        
            return   setAlert({
                 isOpen: true,
                 type: "error",
                 title: t("inventoryError"),
                 subTitle: res.msg,
               });
             
            }
            setLoader(false);
        

        const savedProduct = res?.result;

        if (!id) {
          setAfterInventoryAction(action);
          setNewProduct(savedProduct);
          setShowInventoryForm(true);
          return;
        }

        setSnackbar({
          type: "success",
          show: true,
          msg: res?.msg || t("productUpdatedSuccessfully"),
        });

        // Refresh inventory so POS receives the updated
        // product information, including the new image.
        if (_store?.id) {
          _getById(
            endpoints.Inventory + controller.GetProdsByStore,
            _store.id,
            actions.ActionType.SetInventory,
            () => {
              navigate("/products");
            }
          );
        } else {
          navigate("/products");
        }

      },
      (err) => {
        setLoader(false);

        setSnackbar({
          type: "error",
          show: true,
          msg: err?.message || t("requestFailed"),
        });
      }
    );

      if (id === undefined) {
        values.userId = _authUser.id;
        values.storeId = _store.id;
        _post(
          endpoints.Product,
          ToFormData(RmvEmptyProp(values)),
          actions.ActionType.Data,
          onComplete);
         
      } else if (id !== 0) {
        
        // ✅ UPDATE (with normalization + guard)
            const fixedValues = {
              ...values,
              id: values.id ?? values.payloadid,
            };
            delete fixedValues.payloadid;

            // ✅ Defensive guard
            if (!fixedValues.id) {
              setLoader(false);
              setSnackbar({
                type: "error",
                show: true,
                msg: t("invalidProductIdentifier"),
              });
              return;
            }

        //Convert To FormData
        const formData = new FormData();
        const formVal = RmvEmptyProp(fixedValues);

        Object.keys(formVal).forEach((key) =>
          !Array.isArray(formVal[key])
            ? formData.append(key, formVal[key])
            : key === "imgs"
            ? formVal[key].forEach((val, i) =>
                Object.keys(val).forEach((key1) =>
                  formData.append(`${key}[${i}][${key1}]`, val[key1])
                )
              )
            : formVal[key].forEach((val) => formData.append(key, val))
        );
        // Call API
        _put(endpoints.Product, formData, actions.ActionType.Data, onComplete);
      }
    }
  };

  
     // ✅ Normalize ID early when loading data (BEST PRACTICE)
    useEffect(() => {
      if (id !== undefined && !IsEmptyObj(_data)) {
        setValues(prev => ({
          ...prev,
          ...RmvNullProp(_data),
          id: _data.id ?? _data.payloadid, // ✅ normalize once
        }));
      }     
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [_data, id]);

   const handleGenerateCode = (name) => {  //line194:8
    setValues({
      ...values,
      [name]: Math.floor(10000000000 + Math.random() * 10000000000),
    });
  };

    const purchasePricePerUnit =
    [1, 4, 5].includes(Number(values.unit)) &&
    Number(values.unitsPerPackage) > 0 &&
    Number(values.purchPrice) >= 0
      ? Number(values.purchPrice) / Number(values.unitsPerPackage)
      : null;

    useEffect(() => {
    // PCS or LB always represents one base unit
    if ([2, 3].includes(Number(values.unit))) {
      setValues((prev) => ({
        ...prev,
        unitsPerPackage: 1,
      }));

      setErrors((prev) => ({
        ...prev,
        unitsPerPackage: "",
      }));
    }
  }, [values.unit, setValues, setErrors]);

  // Calculate Sell Price
  useEffect(() => {
    if (
      values.purchPrice &&
      values.profitMargin
    ) {
      const purchPrice = parseFloat(values.purchPrice);
      const profitMargin = parseFloat(values.profitMargin);

      // Box, Case, Pack are purchased as packages
      const isPackage = [1, 4, 5].includes(Number(values.unit));

      const unitsPerPackage =
        isPackage && Number(values.unitsPerPackage) > 0
          ? Number(values.unitsPerPackage)
          : 1;

      // Cost of one sellable unit / PCS
      const purchasePricePerUnit =
        purchPrice / unitsPerPackage;

      // Sell price is price PER PCS
      const sellPrice =
        purchasePricePerUnit +
        (profitMargin / 100) * purchasePricePerUnit;

      setValues((x) => ({
        ...x,
        sellPrice: sellPrice.toFixed(2),
      }));

      setErrors((x) => ({
        ...x,
        sellPrice: "",
      }));
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    values.purchPrice,
    values.profitMargin,
    values.unit,
    values.unitsPerPackage,
  ]);

  useEffect(() => {
    // Get Categories
    _get(endpoints.Category, actions.ActionType.SetCategories);

    // Get Product Data By Product-Id
    if (id !== undefined) {
      _getById(
        endpoints.Product + controller.GetById, //?? suppose to be get product by store
        id,
        actions.ActionType.Data
      );
    }

    
    return () => {

      // ✅ DO NOT clear POS state
      if (from === "pos") return;

      _clear();
      _clear({}, actions.ActionType.ClearData);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    return () => {
      resetFormControls();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Set Category & Update Values.
 
  // Set Subcategory
useEffect(() => {
  if (values.categoryId !== "") {
    setSubCat(
      (_categoriesList ?? [])
        .filter((x) => x.parentCatId === values.categoryId)
        .map((j) => ({
          id: j.id,
          name: j.name,
        }))
    );
  } else {
      setSubCat([]);
    }
  }, [values.categoryId, _categoriesList]);


  // Images Src
  useEffect(() => {
    if (!IsEmptyObj(_data) && _data.imgs) {
      setImgSrc(_data.imgs.map((j) => j.imgUrl));
    }
  }, [_data]);

  return (
    <>
      <Box className="mt-30 br-8 bg-white">
        <Grid container spacing={3} className="p-20 pt-0">
          <Grid item xs={12} className="tx-center mt-20">
            <Typography variant="h5" className="fs-22 gray-color fw-5 tx-upp">
              {id === undefined ? t("addProduct") : t("updateProduct")}
            </Typography>
            <div className="bs-bottom mx-w-80 m-auto mt-10 mb-30" />
          </Grid>
          <Grid item xs={12} md={4}>
            <Input
              label={t("barcode")}
              name="barcode"
              value={values.barcode}
              error={errors.barcode}
              onChange={handleInpChg}
              fullWidth
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Tooltip arrow title={t("generateBarcode")}>
                      <IconButton onClick={() => handleGenerateCode("barcode")}>
                        <ViewWeekRounded />
                      </IconButton>
                    </Tooltip>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} md={8}>
            <Input
              label={t("productName")}
              name="name"
              value={values.name}
              error={errors.name}
              onChange={handleInpChg}
              fullWidth
            />
          </Grid>
          
          <Grid item xs={12} md={4}>
            <Select
              label={t("unitType")}
              name="unit"
              fullWidth
              value={values.unit}
              error={errors.unit}
              onChange={handleInpChg}
              options={UnitType}
            />
          </Grid>

          {[1, 4, 5].includes(Number(values.unit)) && (
            <Grid item xs={12} md={4}>
              <Input
                label={
                  Number(values.unit) === 1
                    ? t("unitsPerBox")
                    : Number(values.unit) === 4
                    ? t("unitsPerCase")
                    : t("unitsPerPack")
                }
                type="number"
                name="unitsPerPackage"
                value={values.unitsPerPackage}
                error={errors.unitsPerPackage}
                onChange={handleInpChg}
                fullWidth
                inputProps={{ min: 1 }}
              />
            </Grid>
          )}

          <Grid item xs={12} md={4}>
            <Select
              label={t("tax")}
              name="tax"
              fullWidth
              value={values.tax}
              error={errors.tax}
              onChange={handleInpChg}
              options={BoolType}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <Select
              label={t("category")}
              name="categoryId"
              fullWidth
              value={values.categoryId}
              error={errors.categoryId}
              onChange={handleInpChg}
              showNA={true}
              options={categories}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <Select
              fullWidth
              label={t("subcategory")}
              name="parentCatId"
              value={values.parentCatId}
              error={errors.parentCatId}
              showNA={true}
              onChange={handleInpChg}
              options={subCat}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <Input
              label={t("purchasePrice")}
              onInput={(e) => (e.target.value = MaxLength(e.target.value, 12))}
              name="purchPrice"
              value={values.purchPrice}
              error={errors.purchPrice}
              onChange={handleInpChg}
              fullWidth
            />
          </Grid>

          {purchasePricePerUnit !== null && (
            <Grid item xs={12} md={4}>
              <Input
                label={t("purchasePricePerUnit")}
                value={purchasePricePerUnit.toFixed(2)}
                fullWidth
                disabled
              />
            </Grid>
          )}

          <Grid item xs={12} md={4}>
            <Input
              label={t("profitMargin")}
              onInput={(e) => (e.target.value = MaxLength(e.target.value, 3))}
              name="profitMargin"
              className="rmv-arrow"
              value={values.profitMargin}
              error={errors.profitMargin}
              onChange={handleInpChg}
              fullWidth
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <PercentRounded />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Input
              label={t("sellPrice")}
              onInput={(e) => (e.target.value = MaxLength(e.target.value, 12))}
              name="sellPrice"
              value={values.sellPrice}
              error={errors.sellPrice}
              onChange={handleInpChg}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Input
              label={t("alertQuantity")}
              type="number"
              name="alertQty"
              onInput={(e) => (e.target.value = MaxLength(e.target.value, 10))}
              value={values.alertQty}
              error={errors.alertQty}
              onChange={handleInpChg}
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <Input
              label={t("productDescription")}
              multiline
              rows={4}
              name="descr"
              value={values.descr}
              error={errors.descr}
              onChange={handleInpChg}
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <InputMultImg
              label={t("productImages")}
              name="imgsFile"
              src={imgSrc}
              values={values.imgsFile}
              onChange={handleFile}
              rmv={(index) => {
                setValues({
                  ...values,
                  imgsFile: values.imgsFile.filter(
                    (j) => j !== values.imgsFile[index]
                  ),
                  imgs: values.imgs.filter((j) => j !== values.imgs[index]),
                });
              }}
            />
          </Grid>
          <Grid item xs={12} className="tx-right">
              {/* ✅ Close (just close, no saving) */}
              <Button
                loading={loader}
                 onClick={() => {
  
                  if (from === "pos") {
                    onSaved?.("cancel");
                    return;
                  }

                  if (from === "purchase") {
                    navigate("/purchases");
                    return;
                  }
                  
                  navigate("/products");
                }}
                sx={{
                  width: { md: "150px", xs: "100%" },
                  mr: { md: "10px", xs: "0px" },
                  mb: { md: "0px", xs: "10px" },
                }}
                size="large"
                color="whitesm"
              >
                {t("close")}
              </Button>

            {id === undefined && (
              <Button
                loading={loader}
                onClick={() => handleSubmit(ACTIONS.EXIT)}
                color="whitesm"
                sx={{
                  minWidth: { md: "150px", xs: "100%" },
                  mr: { md: "10px", xs: "0px" },
                  mb: { xs: "10px", md: "0px" },
                }}
                size="large"
                className="pr-10 pl-10"
              >
                {t("saveAndExit")}
              </Button>
            )}
            <Button
              loading={loader}
              onClick={() => handleSubmit(ACTIONS.ADD_ANOTHER)}
              sx={{ minWidth: { md: "230px", xs: "100%" } }}
              size="large"
            >
              {id === undefined ? t("saveAndAddAnother") : t("saveChanges")}
            </Button>
          </Grid>
        </Grid>
      </Box>
      <Snackbar {...{ snackbar, setSnackbar }} />

      {showInventoryForm && (
        <Dialog open={showInventoryForm} maxWidth="md" fullWidth>
          <AddEditInventory
            //from={from}
            from={from || "product"}
           // returnTo={from || "product"}   // ✅ ADD THIS
            productFromParent={newProduct}            
             
            // ✅ CLOSE INVENTORY MODAL
            onClose={() => {
              setShowInventoryForm(false);

                // ✅ POS flow → return to POS
                if (from  === "pos") {
                  navigate("/pos");   // 🔥 ADD THIS
                  return;
                }

                // ✅ Purchase flow → return to Purchase
                if (from  === "purchase") {
                  navigate("/purchases");   // 👈 FIX HERE
                  return;
                }

                // ✅ Default flow → return to Product list
               if (afterInventoryAction === "exit") {
                  navigate("/products");
                  return;
                }

                if (afterInventoryAction === "add_another") {
                  resetFormControls();
                  setImgSrc([]);
                  setAfterInventoryAction(null);

                  return;
                }
                 navigate("/products"); // fallback
            }}
            
            onSaved={(action) => {

              // POS flow
              if (from === "pos") {
                onSaved?.(action);
                return;
              }

              // SAVE & CLOSE
              if (action === "cancel") {

                setShowInventoryForm(false);
                if (from === "pos") 
                   {
                  navigate("/pos");   // 🔥 ADD THIS
                  return;
                }
                if (from === "purchase")
                   {
                  navigate("/purchases");   // 👈 FIX HERE
                  return;
                }

                if (from === "product") {
                navigate("/products");
                return;
                }

                return;
              }
            }}
              
          />
        </Dialog>
      )}

    </>
  );
};
 
const mapStateToProps = (state) => ({
  _data: state.pos.data,

  _inventoryList: state.pos.inventoryList,
  _categoriesList: state.pos.categoriesList,
  _searchResults: state.pos.searchResults,

  _type: state.pos.type,
  _store: state.pos.defStore,
  _authUser: state.pos.authUser,
});

const mapActionToProps = {
  _post: actions.post,
  _put: actions.put,
  _getById: actions.getById,
  _get: actions.get,
  _clear: actions.clear,
};

export default connect(mapStateToProps, mapActionToProps)(AddEditProd);
